import FactoryComponents from '../../../factory/components/FactoryComponents.js';
import Pointwave from '@/components/components/home/Pointwave';
import {getRoleList} from "@/api/companyManager"
import VueCookies from "vue-cookies"

const root = {}
export default root
var url = ''
root.name = 'home';
root.data = {
    headerShowName: '',
    showMain: false,
    platformName: '安全生产信息化管理平台',
    platformFeatures: [],
    staticFeatures: [
        {menuName: "安全生产智能化系统", value: "33"},
        {menuName: "消防安全智能化系统", value: "1"},
        {menuName: "环境保护智能化系统", value: "-1"},
        /*{menuName:"商贸机构智能化系统",value:"-1"},
        {menuName:"医养机构智能化系统",value:"-1"},
        {menuName:"交通行业智能化系统",value:"-1"},
        {menuName:"水利工程智能化系统",value:"-1"},
        {menuName:"监管机构智能化系统",value:"113"}*/
    ],
};
root.components = {
    Pointwave,
};
root.methods = {
    //获取平台信息
    get: function () {
        const that = this;
        this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').companyInfo).closeLoad()
            .startGet().then((res) => {
            that.platformName = res.body.data.systemName;
            document.title = that.platformName;
            localStorage.setItem("systemName", res.body.data.systemName)
        });
    },

    //获取当前角色能够操作的菜单
    getSelfMenu: function () {
        const that = this;
        // this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').selfMenu)
        // 	.startGet().then((res) => {
        // 		that.componentsMoudel.setData('userDataSelfMenu', res.body.data);
        // 		const selfMenu = that.componentsMoudel.getData('userDataSelfMenu');
        getRoleList().then(res => {
            const selfMenu = res.body.data
            selfMenu.forEach((item, index) => {
                if (item.menuName === '数据可视化') {
                    item.icon = "/visual.png";
                    item.routerUri = '';
                    item.eng = 'VISUALIZATION';
                    item.bgm = '/5.png';
                } else if (item.menuName === '报警') {
                    item.icon = "/alert.png";
                    item.routerUri = '';
                    item.eng = 'CALL THE POLICE';
                    item.bgm = '/3.png';
                } else if (item.menuName === '设备管理') {
                    item.icon = "/facility.png";
                    // item.routerUri = '/equipmentManager';
                    item.eng = 'DEVICE MANAGEMENT';
                    item.bgm = '/2.png';
                } else if (item.menuName === '信息化平台') {
                    item.name = '信息化平台'
                    item.icon = "/productionFlow.png";
                    item.routerUri = '/processManager';
                    item.eng = 'PROCESS MANAGEMENT';
                    item.bgm = '/4.png';
                    //保存用户默认菜单
                    localStorage.setItem('navItem5', JSON.stringify(item.childList))
                    localStorage.setItem('navItem', JSON.stringify(item.childList))
                    localStorage.setItem('routeMenu', JSON.stringify(item.childList))
                } else if (item.menuName === '企业管理') {
                    item.icon = "/companyManager.png";
                    item.routerUri = '/companyManager';
                    item.eng = 'BUSINESS MANAGEMENT';
                    item.bgm = '/1.png';
                    localStorage.setItem('navItem7', JSON.stringify(item.childList))
                } else if (item.menuName === '开放平台') {
                    item.icon = "/openPlatform.png";
                    item.routerUri = '';
                    item.eng = 'OPEN PLATFORM';
                    item.bgm = '/6.png';
                } else if (item.menuName === 'LED') {
                    item.icon = "/led.png";
                    // item.routerUri = '/led';
                    item.eng = 'LED';
                    item.bgm = '/7.png';
                }
            });
            that.platformFeatures = selfMenu
            //that.showMain = true;
        })
    },

    convertImage: function (url) {
        return require('../../../assets/img' + url);
    },

    // 递归方法拿到有路径的第一个菜单栏
    recursion(arr) {
        for (let i in arr) {
            if (arr[i].haveChild === 0) {
                url = arr[i].route
                return
            } else {
                this.recursion(arr[i].childList)
            }
        }
    },

    goPage: function (url) {
        let manufacturer = localStorage.getItem("manufacturer");
        if (url === "/processManager"){
            this.$router.push(url);
        }else {
            if (manufacturer === "wuweiyiti236"){
                /*if(window.location.hostname=='localhost'){
                    location.href="http://localhost:8080/#/HongShengFactory?token="+VueCookies.get("token");
                }else{
                    location.href="http://datav."+window.location.host+"/#/HongShengFactory?token="+VueCookies.get("token");
                }*/
                this.$router.push("/datav");
            }else {
                this.$router.push("/peoplePosition");
            }
        }
    },
    goMenu: function (value) {
        if (value == 33) {
            this.$router.push({
                path: "processManager",
                query: {
                    selectvalue: value
                }
            })
        }
    },
    menuClick: function (menu) {
        url = ''
        // if (itemData.hasAuth) {
        // 	//存储跳转界面的数据
        // 	this.componentsMoudel.setData(uri, itemData);
        // 	this.$router.push({
        // 		path: uri
        // 	})
        // } else {
        // 	this.$message({
        // 		message: '没有权限',
        // 		type: 'error'
        // 	});
        // }
        // console.log(menu, )
        // return
        //存储跳转界面的数据
        this.recursion(menu.childList)
        this.$router.push(url)
        this.componentsMoudel.setData(url, menu.childList);
        localStorage.setItem('navItem', JSON.stringify(menu.childList))
        localStorage.setItem('routeMenu', JSON.stringify(menu.childList))
    },

    outLogin: function () {
        this.componentsMoudel.getRequestHander(this.componentsMoudel.getData('urls').outLogin)
            .openLoad().startGet().then((res) => {
            this.componentsMoudel.clearLocalStorage();
            var keys = document.cookie.match(/[^ =;]+(?==)/g)
            if (keys) {
                for (var i = keys.length; i--;) {
                    document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString() // 清除当前域名下的,例如：m.ratingdog.cn
                    document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString() // 清除当前域名下的，例如 .m.ratingdog.cn
                    document.cookie = keys[i] + '=0;path=/;domain=ratingdog.cn;expires=' + new Date(0).toUTCString() // 清除一级域名下的或指定的，例如 .ratingdog.cn
                }
            }
            this.$router.push({
                path: "/"
            })
        });

    },


};


root.mounted = function () {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.componentsMoudel.setData('userData', userInfo);
    this.headerShowName = "你好 " + userInfo.account;
    this.platformName = userInfo.companyName;
    this.getSelfMenu();
}


FactoryComponents.initComponent(root);
